import styled from '@emotion/styled';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreativeFormatNetwork, CreativeFormatPlacement } from '../../../generated/graphql';

type Props = {
  network?: Pick<CreativeFormatNetwork, 'name'>;
  placement: Pick<CreativeFormatPlacement, 'key' | 'name'>;
  className?: string;
};

const CreativeFormatPlacementLabel: FC<Props> = ({ network, placement, className }) => (
  <PlacementLabel className={className}>
    {network && <span>{network.name} </span>}
    {placement.key !== 'any_network_any_placement' ? (
      placement.name
    ) : (
      <FormattedMessage id="creative_format.any_network_any_placement" />
    )}
  </PlacementLabel>
);

const PlacementLabel = styled('span')`
  line-break: anywhere;
`;

export default CreativeFormatPlacementLabel;
